module.exports = __webpack_public_path__ + "assets/xmcyber_com_login.cad26026.svg";